import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=74eb1f2d"
import script from "./MiniCart.vue?vue&type=script&lang=js"
export * from "./MiniCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74eb1f2d')) {
      api.createRecord('74eb1f2d', component.options)
    } else {
      api.reload('74eb1f2d', component.options)
    }
    module.hot.accept("./MiniCart.vue?vue&type=template&id=74eb1f2d", function () {
      api.rerender('74eb1f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/MiniCart.vue"
export default component.exports